exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_weather_19SaSdDApzys_rUERanSND {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.IA_weatherIcon_Ui5S1QNOLpsMZNcZcC2WA {\n  height: 65%;\n  width: fit-content;\n}\n\n.IA_weatherTemperature_iIMn6JxhqfrusXRnC-w_S {\n  position: relative;\n  text-align: left;\n\n}\n\n.IA_weatherArea_26vYvXbbg7VBEBU44OVSI5 {\n  position: relative;\n  text-align: left;\n  font-weight: lighter;\n  clear: right;\n}", ""]);

// Exports
exports.locals = {
	"IA_weather": "IA_weather_19SaSdDApzys_rUERanSND",
	"IA_weatherIcon": "IA_weatherIcon_Ui5S1QNOLpsMZNcZcC2WA",
	"IA_weatherTemperature": "IA_weatherTemperature_iIMn6JxhqfrusXRnC-w_S",
	"IA_weatherArea": "IA_weatherArea_26vYvXbbg7VBEBU44OVSI5"
};